function getExternalUrlProps (href) {
  return { href, target: '_blank', rel: 'noopener noreferrer' }
}

export {
  getExternalUrlProps
}
